import { differenceInDays } from 'date-fns';

export const checkAvailablePaymentMethodByCreayedAtUser = (
    user: NormalizedUser | null,
    paymentMinDays: PaymentMinDays[] | undefined,
    paymentMethod: PaymentMethodName,
): boolean => {
    if (!user || !paymentMinDays) {
        return true;
    }

    const currentDate = new Date();
    const createdDate = new Date(user.createdAt);

    const minDay = getMinDaysByPaymentMethod(paymentMinDays, paymentMethod);

    if (minDay == -1) {
        return true;
    }

    return differenceInDays(currentDate, createdDate) >= minDay;
};

export const getMinDaysByPaymentMethod = (
    paymentMinDays: PaymentMinDays[],
    paymentMethod: PaymentMethodName,
): number => {
    const paymentMinDay = paymentMinDays.find(
        (paymentMinDay: PaymentMinDays) => paymentMinDay.paymentMethod === paymentMethod,
    );

    if (paymentMinDay) {
        return paymentMinDay.minDays;
    }

    return -1;
};
